import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Typography, Box } from "@curves/ui-base";
import { parseDate } from "@util/moment";
import { EditContactRecordCard } from "@icoach/components/";
import useMessageDialog from "@util/hook/useMessageDialog";

/**
 * 顧客/名單
 * 聯繫資訊Cell 以外的禁止使用
 */
const NonMemberDescribeLabelBox = React.forwardRef((props, ref) => {
	const { targetID, peopleType, contactID, contactDate, contactResultType, contactResultTypeText: resultTypeText, coachName, title, description } = props;
	const setMessageDialog = useMessageDialog();
	const editContactRecordCardRef = useRef(null);
	const [contactState, setContactState] = useState({
		title: "",
		description: "",
	});

	const handleConfirm = (targetID, params) => {
		setContactState({
			title: params?.title,
			description: params?.notes,
		});
	};

	const getTextNote = (text_1, text_2) => {
		let textAry = [];
		if (text_1) textAry.push(text_1);
		if (textAry.length !== 0 && text_2) textAry.push("~");
		if (text_2) textAry.push(text_2);
		return textAry.join("");
	};

	const handleClickNotes = params => {
		setMessageDialog({
			open: true,
			dialogPaperProps: { className: "wx-80rem" },
			title: "近期五筆聯繫紀錄",
			MsgComp: props => <EditContactRecordCard ref={editContactRecordCardRef} {...params} onConfirm={handleConfirm} {...props} />,
			dialogActionsProps: { className: "hide" },
		});
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				setContractState: ({ title: _t, description: _d, ...others }) => {
					setContactState({
						title: _t,
						description: _d,
					});
				},
			};
		},
		// eslint-disable-next-line
		[],
	);

	useEffect(
		() => {
			setContactState({
				title: title,
				description: description,
			});
		},
		// eslint-disable-next-line
		[title, description],
	);

	return (
		<Box className={"cursor-pointer"} style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }} onClick={() => handleClickNotes({ targetID, contactID, peopleType })}>
			<Typography>
				<span>{parseDate(contactDate, "YYYY/MM/DD")}</span>
				&nbsp;
				{contactID === 0 ? <span>簡訊</span> : !!contactResultType && <span>{resultTypeText}</span>}
				{!!coachName && <span>{` - ${coachName}`}</span>}
			</Typography>
			<Typography className={"font-color-3"} style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
				{getTextNote(contactState.title, contactState.description)}
			</Typography>
		</Box>
	);
});

export default NonMemberDescribeLabelBox;
